module.exports = __webpack_public_path__ + "static/media/img-keelo-product-3@3x.d2374770.png";